// extracted by mini-css-extract-plugin
export default {"main":"main_main__vL6Kb","header":"main_header__sHBjz","logo":"main_logo__dpNug","status_bar":"main_status_bar__-6J2k"};